import ProductCard from '@ui/Product/Card/component'
import ShareModal from '@ui/Share/Modal/component'
import { createXhr } from 'assets/core/js/common'
import FavoriteRepository, { Favorite } from 'assets/core/js/module/favorite/repository'
import type { Repository } from 'assets/core/js/module/favorite/repository'

/**
 * Try to import shared favorites by parsing the query string.
 */
function importShared(repository: Repository): void {
  const parameters = new URLSearchParams(window.location.search)
  const parameter = parameters.get('favorites')
  if (parameter === null || typeof parameter !== 'string') {
    return
  }

  const identifiers = parameter.split(',')

  const favorites = identifiers.reverse().map((identifier: string) => new Favorite(identifier))
  repository.add(favorites)
}

/**
 * Initialize the share modal and its button.
 */
function shareModal(): void {
  const modalEl = document.getElementById('dca-favorite-share-modal')

  if (!modalEl) {
    return
  }

  const modal = new ShareModal(modalEl)

  document.querySelectorAll('.list__share').forEach((el) => {
    el.addEventListener('click', () => {
      modal.open()
    })
  })
}

class List {
  container: HTMLElement
  repository: Repository

  constructor(container: HTMLElement, repository: Repository) {
    this.container = container
    this.repository = repository
  }

  initialize(): void {
    this.repository.listen(() => {
      this.update()
    })
    this.update()
  }

  update(): void {
    const favorites = this.repository.get()
    if (favorites.length === 0) {
      this.container.setAttribute('data-favorite-active-content', 'empty_list')

      return
    }

    this.container.setAttribute('data-favorite-active-content', 'list')

    const parameters = new URLSearchParams()
    for (const favorite of favorites) {
      parameters.append('favorites[]', favorite.getIdentifier())
    }
    const url = window.location.href.replace(window.location.search, '').replace(window.location.hash, '')
    const request = createXhr('GET', `${url}?${parameters.toString()}`)
    request.onreadystatechange = () => {
      if (request.readyState !== XMLHttpRequest.DONE) {
        return
      }

      if (request.status === 200 && typeof request.response === 'string') {
        const list = this.container.querySelector('.list')
        if (list !== null) {
          list.innerHTML = request.response

          list.querySelectorAll<HTMLElement>('.product-card').forEach((element) => {
            ProductCard(element, {
              pluginsConfig: {
                favorite: {
                  addedSnackbar: document.getElementById('favorite_snackbar_added') as HTMLElement,
                  addFailedSnackbar: document.getElementById('favorite_snackbar_add_failed') as HTMLElement,
                  removedSnackbar: document.getElementById('favorite_snackbar_removed') as HTMLElement,
                },
              },
            })
          })
          shareModal()

          return
        }
      }

      this.container.setAttribute('data-favorite-active-content', 'empty_list')
    }

    request.send()
  }
}

export default function (): void {
  const container = document.getElementById('favorites')
  if (container === null || !container.hasAttribute('data-favorite-namespace')) {
    return
  }

  const namespace = container.getAttribute('data-favorite-namespace') as string
  const repository = FavoriteRepository.getRepository(namespace)

  importShared(repository)

  window.addEventListener('DOMContentLoaded', () => {
    window.setTimeout(() => {
      const list = new List(container, repository)
      list.initialize()
    }, 500)
  })
}
